import { MarketingRepo } from '@core/repositories'
const resource = "/lists";

export default {
  /**
   * @used 
   * 1. Marketing Contact 360 degree view (Contact Dashboard)
   */
  getList (config) {
    return MarketingRepo.get(`${resource}.json`, config)
  },
};
